if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;

      
        
this.form.addEventListener('submit', (event) => {
  const isDefaultAddCart = this.form.classList.contains('block_default-add-cart');
  if (isDefaultAddCart) {
    event.preventDefault();

    const qtyInput = this.form.querySelector(".quantity__input");
    const enteredQty = parseFloat(qtyInput.value);
    const maxQty = parseFloat(qtyInput.getAttribute("data-max-qty"));
    const isFractional = qtyInput.getAttribute("data-fractional") === "true";
    const step = parseFloat(qtyInput.step) || 1;

    let cartQty = parseFloat(qtyInput.getAttribute("data-cart-quantity"));
    cartQty = isFractional ? cartQty / 4 : cartQty;

    const totalQty = enteredQty + cartQty;

    const errorWrapper = document.querySelector(".product-form__error-message-wrapper");
    const errorMessage = document.querySelector(".product-form__error-message");

    /* 🔴 STEP VALIDATION (NEW LOGIC) */
    const remainder = ((enteredQty * 100) % (step * 100));

    if (remainder !== 0) {
      errorWrapper.removeAttribute("hidden");
      errorMessage.textContent = `Please add quantity in multiples of ${step} ${qtyInput.getAttribute("data-unit-tag")}.`;
      return;
    }

    /* 🔴 MAX QTY VALIDATION (EXISTING) */
    if (enteredQty > maxQty || totalQty > maxQty) {
      errorWrapper.removeAttribute("hidden");
      errorMessage.textContent =
        window.cartStrings.quantityError.replace(
          '[quantity]',
          maxQty + " " + qtyInput.getAttribute("data-unit-tag")
        );
      return;
    }
  }

  this.onSubmitHandler(event);
});





        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.submitButton.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const unitkey= Date.now();
        const fractionalProps = this.querySelector('.fractional_props');
        if(fractionalProps){          
          fractionalProps.value = unitkey;
        }

        const formData = new FormData(this.form);
 
        const quantityInputP = this.closest('product-info');
        const quantityInputWrap = this?.querySelector('.mf-quantity-input');
        const isFractional = quantityInputWrap?.getAttribute('data-fractional');
        if(isFractional == 'true'){
          const quantityInput = quantityInputWrap?.querySelector('input[name="quantity"]');
          if (quantityInput) {
            let quantity = parseFloat(quantityInput.value);
            if (!isNaN(quantity)) {
              quantity = Math.round(quantity/0.25); 
              formData.set('quantity', quantity);
            }
          }
        }

        

        if (this.cart) {
          formData.append('sections',this.cart.getSectionsToRender().map((section) => section.id));
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {

              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;

              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              // window.location = window.routes.cart_url;
              // return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
           
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });

            }
            
        
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
                setTimeout(function () {
                if (document.querySelector('.block_cart-drawer-giftproduct')) {
                    addFreeGiftProduct();
                  }
                  removeShippingProtectionItems()
                 Rebuy.init();
                moodRewars();               
              }, 1500);
            this.classList.add('added');
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.submitButton.querySelector('.loading__spinner').classList.add('hidden');
            CartPerformance.measureFromEvent("add:user-action", evt);
            console.log("Product added to cart:" )

            const swatchProps = this.querySelector('#created-time');

                if (swatchProps != null){
                  swatchProps.value = Math.floor(Date.now() / 1000);
                  console.log(swatchProps, "swatchProps After")
                }



          });
      }

      handleErrorMessage(errorMessage = false) {

        if (this.hideErrors) return;
   
        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
    
          if( errorMessage ==  "[[ custom error ]]" ){
            this.errorMessage.textContent = window.cartStrings.quantityError.replace('[quantity]', this.errorMessage.closest(".product-form").querySelector(".quantity__input").getAttribute("data-max-qty") );
          }else{
            this.errorMessage.textContent = errorMessage;
          }

     
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {    
        return this.form.querySelector('[name=id]');
      }
    }
  );
}




// new js add 
// product card color option  
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.show-more-colors').forEach(btn => {
    btn.addEventListener('click', () => {
      let parentList = btn.closest('.product-option-list');
      if (!parentList) return;

      parentList.querySelectorAll('.hidden-color-mobile, .hidden-color-desktop')
        .forEach(li => li.classList.remove('hidden-color-mobile', 'hidden-color-desktop'));

      btn.parentElement.style.display = 'none';
    });
  });

// product conversionchart-modal
    const btnOpenModal = document.getElementById('openconversionchartModal');
    const chartModal = document.getElementById('product_conversion_chart-modal');
    const chartOverlay = chartModal?.querySelector('.product_conversion_chart-modal-overlay');
    const btnCloseModal = chartModal?.querySelector('.product_conversion_chart_close-popup');
    const modalContent = chartModal?.querySelector('.product_conversion_chart_popup-content');

    if (btnOpenModal && chartModal && chartOverlay && btnCloseModal && modalContent) {
      const toggleChartModal = (isOpen) => {
        chartModal.classList.toggle('active', isOpen);
        chartOverlay.classList.toggle('active', isOpen);
        document.body.style.overflow = isOpen ? 'hidden' : '';
      };

      // Open modal on either link click
      btnOpenModal.addEventListener('click', () => toggleChartModal(true));
      btnCloseModal.addEventListener('click', () => toggleChartModal(false));
      chartOverlay.addEventListener('click', () => toggleChartModal(false));

      document.body.addEventListener('click', (e) => {
        if (
          chartModal.classList.contains('active') &&
          !modalContent.contains(e.target) &&
          !btnOpenModal.contains(e.target) 
        ) {
          toggleChartModal(false);
        }
      });
    }

// product_comparelist-modal
  let productComparelistOpenButton = document.getElementById('openCompareModal');
  let productComparelistModal = document.getElementById('product_comparelist-modal');
  let productComparelistOverlay = productComparelistModal?.querySelector('.product_comparelist-modal-overlay');
  let productComparelistCloseButton = productComparelistModal?.querySelector('.product_comparelist_close-popup');
  let productComparelistContent = productComparelistModal?.querySelector('.product_comparelist_popup-content');

  if (
    productComparelistOpenButton &&
    productComparelistModal &&
    productComparelistOverlay &&
    productComparelistCloseButton &&
    productComparelistContent
  ) {
    let toggleProductComparelistModal = (isOpen) => {
      productComparelistModal.classList.toggle('active', isOpen);
      productComparelistOverlay.classList.toggle('active', isOpen);
      document.body.style.overflow = isOpen ? 'hidden' : '';
    };

    productComparelistOpenButton.addEventListener('click', () => toggleProductComparelistModal(true));
    productComparelistCloseButton.addEventListener('click', () => toggleProductComparelistModal(false));
    productComparelistOverlay.addEventListener('click', () => toggleProductComparelistModal(false));

    document.body.addEventListener('click', (event) => {
      if (
        productComparelistModal.classList.contains('active') &&
        !productComparelistContent.contains(event.target) &&
        !productComparelistOpenButton.contains(event.target)
      ) {
        toggleProductComparelistModal(false);
      }
    });
  }

 // product_returnable modal
  let productReturnableOpenButton = document.getElementById('openreturnableModal');
  let productReturnableModal = document.getElementById('product_returnable-modal');
  let productReturnableOverlay = productReturnableModal?.querySelector('.product_returnable-modal-overlay');
  let productReturnableCloseButton = productReturnableModal?.querySelector('.product_returnable_close-popup');
  let productReturnableContent = productReturnableModal?.querySelector('.product_returnable_popup-content');

  if (
    productReturnableOpenButton &&
    productReturnableModal &&
    productReturnableOverlay &&
    productReturnableCloseButton &&
    productReturnableContent
  ) {
    let toggleProductReturnableModal = (isOpen) => {
      productReturnableModal.classList.toggle('active', isOpen);
      productReturnableOverlay.classList.toggle('active', isOpen);
      document.body.style.overflow = isOpen ? 'hidden' : '';
    };

    productReturnableOpenButton.addEventListener('click', () => toggleProductReturnableModal(true));
    productReturnableCloseButton.addEventListener('click', () => toggleProductReturnableModal(false));
    productReturnableOverlay.addEventListener('click', () => toggleProductReturnableModal(false));

    document.body.addEventListener('click', (event) => {
      if (
        productReturnableModal.classList.contains('active') &&
        !productReturnableContent.contains(event.target) &&
        !productReturnableOpenButton.contains(event.target)
      ) {
        toggleProductReturnableModal(false);
      }
    });
  }

  
 // product_reorderable modal
  let productReorderableOpenButton = document.getElementById('openreorderableModal');
  let productReorderableModal = document.getElementById('product_reorderable-modal');
  let productReorderableOverlay = productReorderableModal?.querySelector('.product_reorderable-modal-overlay');
  let productReorderableCloseButton = productReorderableModal?.querySelector('.product_reorderable_close-popup');
  let productReorderableContent = productReorderableModal?.querySelector('.product_reorderable_popup-content');

  if (
    productReorderableOpenButton &&
    productReorderableModal &&
    productReorderableOverlay &&
    productReorderableCloseButton &&
    productReorderableContent
  ) {
    let toggleProductReorderableModal = (isOpen) => {
      productReorderableModal.classList.toggle('active', isOpen);
      productReorderableOverlay.classList.toggle('active', isOpen);
      document.body.style.overflow = isOpen ? 'hidden' : '';
    };

    productReorderableOpenButton.addEventListener('click', () => toggleProductReorderableModal(true));
    productReorderableCloseButton.addEventListener('click', () => toggleProductReorderableModal(false));
    productReorderableOverlay.addEventListener('click', () => toggleProductReorderableModal(false));

    document.body.addEventListener('click', (event) => {
      if (
        productReorderableModal.classList.contains('active') &&
        !productReorderableContent.contains(event.target) &&
        !productReorderableOpenButton.contains(event.target)
      ) {
        toggleProductReorderableModal(false);
      }
    });
  }

  document.querySelectorAll('.block__enhance-products-slider.swiper').forEach(slider => {
    new Swiper(slider, {
      spaceBetween: 12,
      loop: false,
      navigation: {
        nextEl: '.block__enhance-products-slider-arrow-right',
        prevEl: '.block__enhance-products-slider-arrow-left',
      },
      pagination: {
        el: slider.querySelector('.swiper-pagination'),
        type: 'progressbar',
      },
      breakpoints: {
        0: { slidesPerView: 2, spaceBetween: 12, dots: true },
        768: { slidesPerView: 2.5, spaceBetween: 12, dots: true },
        1200: { slidesPerView: 2.8, spaceBetween: 16.8 }
      }
    });
  });

  // Onload Remove Disable on ATC Botton
  // const submitBtn = document.querySelector(".product-form__buttons .product-form__submit");
  // if (submitBtn && submitBtn.classList.contains("disabled")) {
  //   submitBtn.classList.remove("disabled");
  // }
const submitButtons = document.querySelectorAll(
  ".product-form__buttons .product-form__submit");

submitButtons.forEach(btn => {
  if (btn.classList.contains("block_sold-out-products")) return;
  btn.classList.remove("disabled");
  btn.removeAttribute("disabled");
});

});
